import { useEffect, useState } from 'react';

import type { ProjectUserResponse } from '@/domain/models/project.js';
import type { ProjectController } from '@/presentation/controllers/project-controller.js';
import type { UserProfile } from '@/shared/utils/format-status.js';

export function useProjectMembers(projectController: ProjectController, projectId: string | undefined, role: UserProfile, enabled: boolean): ProjectUserResponse[] {
    const [members, setMembers] = useState<ProjectUserResponse[]>([]);

    useEffect(() => {
        if (!enabled || !projectId) {
            return;
        }
        let isStale = false;
        projectController
            .listProjectUsers(projectId, role)
            .then((result) => {
                if (isStale) {
                    return;
                }
                result.fold(
                    () => setMembers([]),
                    (users) => setMembers(users)
                );
            })
            .catch(() => {
                if (!isStale) {
                    setMembers([]);
                }
            });
        return () => {
            isStale = true;
        };
    }, [projectController, projectId, role, enabled]);

    return members;
}
